import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldWorkCost']),
        getByContact: (state) => idContact => {
            return state.objs.filter(wc => wc.contact === idContact);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldWorkCost'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldWorkCost'])
    },
}